export default __webpack_public_path__ + "static/media/MY_TRACKER_ICON_4.f0539858.svg";